<div *ngIf="item.cells['Tooltip'] && item.cells['Tooltip'].value" class="locked-triangle">
  <i class="fal fa-info-circle" matTooltip="{{item.cells['Tooltip'].value}}"></i>
</div>
<button mat-button class="grid-button grid-button-v2"  [@.disabled]="true" [matMenuTriggerFor]="menu"
        particleAnalytics
        [disabled]="isLocked"
        analyticsCategory= "action-type-cell-viewer"
        analyticsAction= "action-button">
  <!--<div class="fflag fflag-DZ ff-lg" title="Algeria DZ"></div>-->
  <span class="text">
    {{item.cells[fieldDefinition.key] && item.cells[fieldDefinition.key].displayText ? item.cells[fieldDefinition.key].displayText: 'Actions'}}</span>
  <i class="fas fa-angle-down"></i>
  <i class="fa-regular fa-ellipsis"></i>
</button>


<mat-menu class="activity-menu" #menu="matMenu">
  <button mat-menu-item *ngFor="let action of actions"
          (click)="onSelectActionType(action)"
          [matTooltip]="action.id=='MoveToYearly'||action.id=='CopyToYearly' ? yearlyTooltip : null"
          particleAnalytics
          analyticsCategory= "action-type-cell-viewer"
          analyticsAction= "action-dropdown"
          [analyticsName]= "action">
    <span>{{selectedList.length > 0 ?action.title:action.text}}</span>
  </button>

</mat-menu>
